import { Injectable } from "@angular/core";
import { GlobalConstants } from "../../constants";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  ComponentSecurity,
  ComponentSecurityAdapter
} from "../Model/component-security";
import * as moment from "moment";

@Injectable({
  providedIn: "root"
})
export class ComponentSecurityService {
  private baseURL =
    GlobalConstants.BASE_API_URL + ":" + GlobalConstants.BASE_API_URL_PORT;

  constructor(
    private httpClient: HttpClient,
    private adapter: ComponentSecurityAdapter
  ) {}

  canUpdate(component: string, user: string): Observable<ComponentSecurity[]> {
    const url = `${this.baseURL}/componentSecurity/api/get/byComponentAndUser`;
    const params = { componentName: component, user: user };
    return this.httpClient.post(url, params).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
    );
  }

  getAll(): Observable<ComponentSecurity[]> {
    const url = `${this.baseURL}/componentSecurity/api/get/all`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
    );
  }

  checkForDuplicate(componentName, user, id) {
    // If id is <> null, then it is an update and need to make sure
    // not checking for a duplicate on it's on record ID, else
    // check without ID on a create
    if (id != null) {
      const url = `${this.baseURL}/componentSecurity/api/check/duplicate`;
      const params = { componentName: componentName, user: user, id: id };
      return this.httpClient.post(url, params).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
      );
    } else {
      // Creation duplicate check, since no ID.  No need to check by ID
      const url = `${
        this.baseURL
      }/componentSecurity/api/get/byComponentAndUser`;
      const params = { componentName: componentName, user: user };
      return this.httpClient.post(url, params).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
      );
    }
  }

  update(formData, id) {
    // Format lastUpdated to IBM i standards
    formData.lastUpdated = moment().format("YYYY-MM-DD-HH.mm.ss");

    // Add database ID to the JSON object for update service
    formData.ID = id;
    formData.changeID = localStorage.getItem("user");
    const url = `${this.baseURL}/componentSecurity/api/update`;
    return this.httpClient.post(url, formData);
  }

  delete(id) {
    const url = `${this.baseURL}/componentSecurity/api/delete`;
    return this.httpClient.post(url, { ID: id });
  }

  create(formData) {
    formData.changeID = localStorage.getItem("user");

    const url = `${this.baseURL}/componentSecurity/api/create`;
    return this.httpClient.post(url, formData);
  }
}
